import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDemo } from '../context/DemoContext';

/**
 * Watches the URL and fires demo step advances for navigation-only steps:
 *   - Step 6 (Visit Submitted Deals) → fires when /submitted-deals is reached → advance to 7
 *   - Step 8 (Tour Funded Chart) → fires when /funded-deals is reached → advance to 9
 *   - Step 9 (Open Deal) → fires when /deals/:id is opened → bumps to 10 only if user has
 *     already toggled auto-clear (handled by axios interceptor); otherwise stays.
 *
 * Renders nothing.
 */
const DemoRouteWatcher = () => {
  const { isDemo, active, step, advance } = useDemo();
  const location = useLocation();

  useEffect(() => {
    if (!isDemo || !active) return;
    const path = location.pathname;

    // Step 5 → 6: user reached Submitted Deals
    if (step === 5 && path === '/submitted-deals') {
      advance(6);
    }
    // (Step 7 "Tour Funded Chart" is manual-advance via banner button.)
    // (Step 8 "Open the Deal" is manual-advance via banner button.)
  }, [isDemo, active, step, location.pathname, advance]);

  return null;
};

export default DemoRouteWatcher;
